export const ATTACHED_DATA_BLOCK_TYPES = {
  ACCORDION: 'accordion',
  BADGE_LIST: 'badge-list',
  PHONE_NUMBER: 'phone-number',
  DYNAMIC: 'dynamic',
};

